/* eslint-disable */
import React from 'react';
import { useContext, useState, useEffect } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import useApp from '../../../hooks/useApp';
import useSWR from 'swr';
import { fetcher } from '../../../service/SWRFetcher';
import filterStyles from '../../filterStyles';
import { Box, Button, Grid } from '@material-ui/core';

const DatePeriodFilter = ({ userId, filters, setFilters }) => {
  const classes = filterStyles();

  const { partners: allPartners, insurances } = useApp();
  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();
  const [dates, setDates] = useState({
    date_ini: dateLastMonth,
    date_end: dateNow,
  });
  const [partners, setPartners] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const [brokerId, setBrokerId] = useState();

  const { values, getters, creators } = useContext(MainContext);

  var partners_ids = [];

  const { data: users } = useSWR(`/users`, fetcher, { revalidateOnFocus: false });

  function handlePartners(e, v) {
    e.preventDefault();
    setPartners([]);
    v.forEach((element) => {
      setPartners([...partners, element.id]);
    });
  }

  function handleSubmit(event, getters) {
    event.preventDefault();
    // console.log(event.target.elements)

    let filters = {
      date_ini: event.target.elements[0].value,
      date_end: event.target.elements[1].value,
      partner_id: `[${partners.join(',')}]`,
      insurance_id: insurance.map((i) => ({ id: i.id })) || null,
      broker_id: brokerId?.map((b) => ({ id: b.id })) || null,
      paginate: null,
    };
    setFilters(filters);
    // console.log(filters)
    // getters.getLostSaleReport(filters)
  }

  return (
    <Box className={classes.boxFilter}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_ini"
                placeholder="Data Inicial"
                value={dates.date_ini}
                onChange={(e) => setDates(e)}
              />
            </Grid>

            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_end"
                placeholder="Data Final"
                value={dates.date_end}
                onChange={(e) => setDates(e)}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                className={classes.inputSelect}
                options={allPartners}
                getOptionLabel={(option) => option?.name}
                onChange={(e, v) => handlePartners(e, v)}
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Empresa" />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                className={classes.inputSelect}
                multiple
                options={insurances ? insurances.filter((i) => i.id <= 3) : []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => setInsurance(value)}
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Tipos de Estoque" />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                className={classes.inputSelect}
                options={users ? users : []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => setBrokerId(value)}
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
                )}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} type="submit">
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DatePeriodFilter;
